import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { IfFeatureEnabledService } from '../services/if-feature-enabled.service';

const directiveName = 'ifFeatureEnabled';

@Directive({
  selector: `[${directiveName}]`
})
export class IfFeatureEnabledDirective {
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private readonly ifFeatureEnabledService: IfFeatureEnabledService) {
  }

  @Input(directiveName)
  set featurePath(featurePath: string) {
    const isActive = this.ifFeatureEnabledService.isFeatureEnabled(featurePath);
    if (isActive && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!isActive && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
